var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.requestPayment}},[_vm._t("default")],2),_vm._v(" "),_c('services',{ref:"services",on:{"click":function($event){$event.stopPropagation();}}}),_vm._v(" "),_c('dialogCode',{ref:"dialogCode",on:{"event":_vm.payedDialogEvent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5921bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/requestPayment.vue
// module id = null
// module chunks = 